import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates'
import { TextBoxField, FormGroup } from '@appbase/components/forms'
import GridView from '@/modules/@appbase/components/GridView/GridView.vue'

import api from '@webparts/api'

@Component({
    components: {
        ModalLayout,
        TextBoxField,
        FormGroup,
        GridView
    }
})
export default class RandomImageSettingModal  extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: String }) webpartId!: string;

    imageList: gridView.ModelItem<kyobobook.Image>[] = [];
    curImage: kyobobook.Image = this.setImageInitVal();
    imageSetting: boolean = false;
    selectedImages: kyobobook.Image[] = [];

    headers: Array<gridView.Header> = [
        { displayName: this.$t('제목').toString(), rowKey: 'title', width: '120' },
        { displayName: '', rowKey: '', slotName: 'order', width: '40', align: 'center' },
        { displayName: '', rowKey: '', slotName: 'edit', width: '60' },
    ];

    imageDeleted: string = '';

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    handleClose() {
        this.closeCurrentModal();
    }

    load() {
        api.kyobobook.getImageListAdmin(this.webpartId).then((res) => {
            if (res) {
                this.imageList = res;
            }
        });
    }

    // 이미지 초기값
    setImageInitVal() {
        return {
            webpartId: this.webpartId,
            title: "",
            image: "",
            linkUrl: "",
            order: 0,
            isUse: true,
        }
    }

    // 이미지 추가
    addImage() {
        this.imageSetting = true;
        this.curImage = this.setImageInitVal();
    }

    // 이미지 수정
    editImage(val: number) {
        let selected = this.imageList.find(i => i.id == val);
        this.curImage = selected as kyobobook.Image;
        this.imageSetting = true;
    }

    // 이미지 삭제
    async deleteImage() {
        if (!this.curImage.id) return;
        
        if(await (window as any).confirmAsync(this.$t('삭제_하시겠습니까').toString())) {
            api.kyobobook.deleteImage(this.webpartId, this.curImage.id).then(res => {
                if(res > 0) {
                    (window as any).alertAsync(this.$t('삭제_되었습니다').toString());
                    this.load();
                    this.imageSetting = false;
                } else {
                    (window as any).alertAsync(this.$t('삭제_실패').toString());
                }
            })
        }
    }

    // 이미지 저장
    async saveImage() {
        if(this.imageDeleted != ''){
            this.onImageFileDelete();
        }

        if(await this.checkFieldValidate()) {
            if(!this.curImage.id) {
                api.kyobobook.createImage({
                    ...this.curImage,
                    webpartId: this.webpartId,
                }).then(async res => {
                    if(res > 0) {
                        await (window as any).alertAsync(this.$t('저장되었습니다').toString());
                        this.load();
                        this.imageSetting = false;
                    } else {
                        (window as any).alertAsync(this.$t('저장_실패').toString());
                    }
                });
            } else {
                api.kyobobook.updateImage({
                    ...this.curImage,
                    webpartId: this.webpartId,
                }).then(async res => {
                    if(res > 0) {
                        await (window as any).alertAsync(this.$t('수정되었습니다').toString());
                        this.load();
                        this.imageSetting = false;
                    } else {
                        (window as any).alertAsync(this.$t('수정_실패').toString());
                    }
                });
            }
        }
    }

    async checkFieldValidate() {
        if(this.imageSetting) {
            if(this.curImage.linkUrl.includes('api/processToken')){
                var url = new URL(this.curImage.linkUrl)
                var search = url.search
                if(search.indexOf('?',1)!==-1){
                    var innerParam = search.slice(search.indexOf('?',1)+1)
                    url.search = url.search.replace(innerParam,encodeURIComponent(innerParam))
                }
                this.curImage.linkUrl = url.toString()
            }

            if(this.curImage.title.trim().length == 0) {
                await (window as any).alertAsync(this.$t('제목을_입력해주세요').toString());
                return false;
            }

            if(this.curImage.image.trim().length == 0) {
                await (window as any).alertAsync(this.$t('이미지를_첨부해주세요').toString());
                return false;
            }
            return true;
        }
    }

    onSelectImageClick() {
        var inpElem = this.$refs.inpFile as HTMLInputElement;
        inpElem.click();
    }

    onImageFileChanged(e: Event) {
        var inpElem = e.target as HTMLInputElement;
                
        if(inpElem.files && inpElem.files.length > 0) {
            var targetFile = inpElem.files[0] as any;    
            var request =  new XMLHttpRequest();        
            var formData = new FormData();
            request.addEventListener("load", this.onImageUploaded)                      
            request.open('POST', '/cm/Webpart/WebpartImage/api/uploadImageFile');
                        
            formData.append('imageFile',  targetFile);
            
            request.send(formData);
        }   
    }

    onImageUploaded(e: ProgressEvent) {
        var request = e.currentTarget as XMLHttpRequest;
        var response = JSON.parse(request.response);        
        this.curImage.image = response.result;
    } 

    onDeleteImageClick(){
        if(this.curImage.image) {
            this.imageDeleted = this.curImage.image;
            this.curImage.image = '';
        }
    }

    onImageFileDelete() {
        var request =  new XMLHttpRequest();        
        request.open('DELETE',`/cm/Webpart/WebpartImage/api/deleteImageFile?fileName=${this.imageDeleted}`)
        request.send();
    } 

    getImageSource(fileName: string) {
        return `/cm/Webpart/WebpartImage/api/getImageFile?fileName=${encodeURIComponent(fileName)}`;
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    mounted() {
        this.load();
    }
}